import React from "react";
import "./index.css";

export const NotFound: React.FC = () => {
  return (
    <div className="notfound">
      <div>
        ======
        <br />
        Hope
        <br />
        for peace
        <br />
        por la paz
        <br />
        世界平和
        <br />
        per la paix
        <br />
        brings us
        <br />
        together. <br />
        ======
        <br />
      </div>
    </div>
  );
};
